import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'audiences'
const verb = 'get'

export default class OspreyAudienceGetById extends BaseAction {
    constructor(dataKey) {
        const id = 'b696cd44-f65e-4861-8ecb-a6b368c3bf1a'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getById(audienceId) {
        this.path = `/${resource}/${audienceId}`

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/audiences/audience-get-by-id.js